import IFlowModelForUser from '@Shared.Angular/@types/core/contracts/queryModel/flows/flowModelForUser';
import { FlowModelPublishType } from '@Shared.Angular/flowingly.services/flowingly.constants';

export interface IComponentWarningData {
  componentTypeName: string;
  flowModelNames: string[];
}

const COMPONENT_TYPE_DISPLAY_NAMES = {
  WORKFLOW: 'Workflow',
  PROCESS_MAP: 'Process Map'
} as const;

export type ComponentTypeName =
  (typeof COMPONENT_TYPE_DISPLAY_NAMES)[keyof typeof COMPONENT_TYPE_DISPLAY_NAMES];

export const getComponentTypeNameFromPublishType = (
  publishTypeValue?: number
): ComponentTypeName | null => {
  if (publishTypeValue === FlowModelPublishType.WorkflowComponent) {
    return COMPONENT_TYPE_DISPLAY_NAMES.WORKFLOW;
  }
  if (publishTypeValue === FlowModelPublishType.ProcessMapComponent) {
    return COMPONENT_TYPE_DISPLAY_NAMES.PROCESS_MAP;
  }
  return null;
};

export const buildComponentWarningData = (
  componentTypeName: ComponentTypeName,
  flowModels: IFlowModelForUser[]
): IComponentWarningData => {
  const flowModelNames: string[] = flowModels
    .map((flowModel) => flowModel.name)
    .sort((left, right) => left.localeCompare(right));

  return { componentTypeName, flowModelNames };
};
